import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const pagination = {
  namespaced: true,

  state: () => ({
    paginationData: {
      data: [],
      // ----------------
      paginationParams: {
        MerchantId: '',
        DateFrom: '01/01/1970',
        DateTo: new Date().toLocaleDateString('en-ng'),
        SearchValue: 'all',
        PageNumber: 1,
        PageSize: 10,
        DefaultPage: 1
      },
      // ----------------
      firstPage: '',
      lastPage: '',
      nextPage: '',
      previousPage: '',
      totalPages: 0,
      totalRecords: 0
    },
    refreshRecords: false
  }),

  getters: {
    _paginationData: state => state.paginationData.data,
    // -----------------------------------------------------------
    _paginationParams: state => state.paginationData.paginationParams,
    // -----------------------------------------------------------
    _firstPage: state => state.paginationData.firstPage,
    _lastPage: state => state.paginationData.lastPage,
    _nextPage: state => state.paginationData.nextPage,
    _previousPage: state => state.paginationData.previousPage,
    _totalPages: state => state.paginationData.totalPages,
    _totalRecords: state => state.paginationData.totalRecords,
    // -----------------------------------------------------------
    _refreshRecords: state => state.refreshRecords
  },

  mutations: {
    PAGINATION_DATA (state, data) {
      state.paginationData.data = data
    },
    // -----------------------------------------------------------
    PAGINATION_PARAMS (state, data) {
      state.paginationData.paginationParams = data
    },
    UPDATE_PAGINATION_MERCHANT_ID (state, id) {
      state.paginationData.paginationParams.MerchantId = id
    },
    UPDATE_PAGINATION_DATES (state, { dateFrom, dateTo }) {
      state.paginationData.paginationParams.DateFrom = dateFrom
      state.paginationData.paginationParams.DateTo = dateTo
    },
    UPDATE_PAGINATION_SEARCH_VALUE (state, searchValue) {
      state.paginationData.paginationParams.SearchValue = searchValue
    },
    UPDATE_PAGINATION_PAGE_NUMBER (state, pageNumber) {
      state.paginationData.paginationParams.PageNumber = pageNumber
    },
    UPDATE_PAGINATION_PAGE_SIZE (state, pageSize) {
      state.paginationData.paginationParams.PageSize = pageSize
    },
    UPDATE_PAGINATION_DEFAULT_PAGE (state, page) {
      state.paginationData.paginationParams.DefaultPage = page
    },
    // -----------------------------------------------------------
    PAGINATION_FIRST_PAGE (state, str) {
      state.paginationData.firstPage = str
    },
    PAGINATION_LAST_PAGE (state, str) {
      state.paginationData.lastPage = str
    },
    PAGINATION_NEXT_PAGE (state, str) {
      state.paginationData.nextPage = str
    },
    PAGINATION_PREVIOUS_PAGE (state, str) {
      state.paginationData.previousPage = str
    },
    PAGINATION_TOTAL_PAGES (state, str) {
      state.paginationData.totalPages = str
    },
    PAGINATION_TOTAL_RECORDS (state, str) {
      state.paginationData.totalRecords = str
    },
    // -----------------------------------------------------------
    REFRESH_RECORDS (state, value) {
      state.refreshRecords = value
    }
  },

  actions: {
    NextPage ({ rootState, state, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api.get(state.nextPage, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    PreviousPage ({ rootState, state, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api.get(state.previousPage, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default pagination
